import Base from 'app/views/base';

import tmpl from 'templates/checkout-success-page';
import { clearStoredValue } from 'utils/storage';

export default Base.extend({
  compiledTemplate: tmpl,
  className: 'checkout',
  initialize({userLoggedIn}) {
    this.userLoggedIn = userLoggedIn;
    this.plan = JSON.parse(clearStoredValue('epsubplan')) || {};
  },
  context() {
    return {
      loggedIn: this.userLoggedIn,
      planQuantity: this.plan.quantity,
      planInterval: this.plan.interval,
      planName: this.plan.name,
      planPrice: this.plan.price,
    }
  }
});



// WEBPACK FOOTER //
// ./app/views/checkout_success_page.js